<template>
  <div>
    <ots-main-title></ots-main-title>
  
    <ots-table-group-new  
      :selectList="selectList"
      :requestForm="requestForm"
      @search="search"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
    ></ots-table-group-new>  

    <!-- 确认弹窗 - 设置口令 -->
    <ots-custom-dialog :dialog.sync="setPasswordDialog" title="请设置试卷变更口令" width="60%">
      <template v-slot:content>
        <el-form :model="setPasswordForm" :rules="setPasswordRules" ref="setPasswordForm" label-width="100px">
          <el-form-item label="口令" prop="versionChangeOrder">
            <el-input
              v-model="setPasswordForm.versionChangeOrder"
              placeholder="请输入 6 位数字口令"
              maxlength="6"
              type="password"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="确认" prop="confirmPassword">
            <el-input
              v-model="setPasswordForm.confirmPassword"
              placeholder="请再次输入 6 位数字口令"
              maxlength="6"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-alert
            title="重要提示"
            type="warning"
            :closable="false"
            show-icon
          >
            <template slot="default">
              <p class="alert-text">1）提交后，该场次的版本号将自动更新，所有关联考场的试卷将重新生成（无论该考场是否有试卷内容变更）；</p>
              <p class="alert-text">2）请务必在试卷生成状态为"已生成"后，下载该场次的最新试卷，并将其上传至该场次对应的全部考场管理机。请在管理机页面核对场次版本号，确保一致后，方可确认试卷更换成功；</p>
              <p class="alert-text" style="font-weight: bold;color: red;">3）试卷变更口令请妥善保管，再次提交试卷确认或取消变更时需要验证。</p>
            </template>
          </el-alert>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="setPasswordDialog = false">取消</el-button>
        <el-button round type="primary" @click="handleSetPassword">确认提交</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 确认弹窗 - 录入口令 -->
    <ots-custom-dialog :dialog.sync="inputPasswordDialog" title="请录入试卷变更口令" width="60%">
      <template v-slot:content>
        <el-form :model="inputPasswordForm" :rules="inputPasswordRules" ref="inputPasswordForm" label-width="100px">
          <el-form-item label="口令" prop="versionChangeOrder">
            <el-input
              v-model="inputPasswordForm.versionChangeOrder"
              :placeholder="currentVersionChangeOrder"
              maxlength="6"
              type="password"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-alert
            title="重要提示"
            type="warning"
            :closable="false"
            show-icon
          >
            <template slot="default">
              <p class="alert-text">1）提交后，该场次的版本号将自动更新，所有关联考场的试卷将重新生成（无论该考场是否有试卷内容变更）；</p>
              <p class="alert-text">2）请务必在试卷生成状态为"已生成"后，下载该场次的最新试卷，并将其上传至该场次对应的全部考场管理机。请在管理机页面核对场次版本号，确保一致后，方可确认试卷更换成功；</p>
              <p class="alert-text" style="font-weight: bold;color: red;">3）试卷变更口令请妥善保管，再次提交试卷确认或取消变更时需要验证。</p>
            </template>
          </el-alert>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="inputPasswordDialog = false">取消</el-button>
        <el-button round type="primary" @click="handleInputPassword">确认提交</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 取消确认弹窗 -->
    <ots-custom-dialog :dialog.sync="unConfirmDialog" title="取消试卷变更" width="50%">
      <template v-slot:content>
        <el-form :model="unConfirmForm" :rules="unConfirmRules" ref="unConfirmForm" label-width="100px">
          <el-form-item label="口令" prop="versionChangeOrder">
            <el-input
              v-model="unConfirmForm.versionChangeOrder"
              :placeholder="unConfirmVersionChangeOrder"
              maxlength="6"
              type="password"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-alert
            title="重要提示"
            type="warning"
            :closable="false"
            show-icon
          >
            <template slot="default">
              <p class="alert-text">1）取消后该场次所有考场试卷将恢复至上一版本。</p>
            </template>
          </el-alert>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button round @click="unConfirmDialog = false">取消</el-button>
        <el-button round type="primary" @click="handleUnConfirm">确认取消</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 下载弹窗 -->
    <ots-custom-dialog :dialog.sync="downloadDialog" title="下载试卷" width="60%">
      <template v-slot:content>
        <div style="text-align: center; margin-bottom: 20px;">
          <el-button type="primary" size="large" @click="handleDownload">下载试卷</el-button>
        </div>
        <el-divider content-position="left">下载日志</el-divider>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in downloadLogList"
            :key="index"
            :timestamp="item.createDate"
            placement="top"
          >
            <div class="download-info">
              <div class="download-info-s"><strong>场次名称：</strong>{{ item.sessionName }}</div>
              <div class="download-info-v"><strong>试卷版本号：</strong>{{ item.versionNumberName }}</div>
              <div class="download-info-u"><strong>下载用户：</strong>{{ item.createUserId }}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
        <div v-if="downloadLogList.length === 0" style="text-align: center; color: #909399; padding: 20px;">
          暂无下载日志
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="downloadDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>

import {  
    getPlanListApi,
    getSessionListApi,
    getConfirmListApi,
    confirmSessionVersionApi,
    unConfirmSessionVersionApi,
    downloadSessionVersionApi,
    downloadGetLogListApi
} from "@/http/modules/examSet/confirmChangePaper";


export default {
  name: "confirmChangePaper",
  data() {
    return {
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
          isSearch: true,
        },
        {
          title: "场次",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [
            {name: "全部", id: ""}
          ],
        },
        {
          title: "确认状态",
          type: "select",
          requestKey: "confirmState",
          label: "name",
          value: "id",
          data: [
            {name: "全部", id: ""},
            {name: "未确认", id: 0},
            {name: "已确认", id: 1}
          ],
        },
        {
          title: "生成状态",
          type: "select",
          requestKey: "executeState",
          label: "name",
          value: "id",
          data: [
            {name: "全部", id: ""},
            {name: "队列中", id: 0},
            {name: "生成中", id: 1},
            {name: "已生成", id: 2}
          ],
        },
      ],
      tableHeader: [
        {
          title: "场次",
          prop: "sessionName",
        },
        {
          title: "考试时间",
          prop: "examTimes",
        },
        {
          title: "试卷变更",
          prop: "paperNames",
        },
        {
          title: "版本号",
          prop: "versionNumberName",
        },
        {
          title: "确认状态",
          prop: "confirmStateName",
        },
        {
          title: "生成状态",
          prop: "executeStateName",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "确认",
              // 未确认状态时可点击，已确认时禁用
              formatter: (val) => val.row.confirmState !== 0,
              click: this.showConfirmDialog,
            },
            {
              title: "取消",
              // 已确认 且 生成状态为队列中时可点击，其他情况禁用
              formatter: (val) => !(val.row.confirmState == 1 && val.row.executeState == 0),
              click: this.showUnConfirmDialog,
            },
            {
              title: "下载",
              // 已生成时可点击，其他状态禁用
              formatter: (val) => val.row.executeState !== 2,
              click: this.showDownloadDialog,
            },
          ],
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      requestForm: {
        planId: "",
        sessionId: "",
        confirmState: "",
        executeState: "",
        size: 10,
        page: 1,
      },
      // 当前行的 versionChangeOrder 值，用于判断是设置口令还是录入口令
      currentVersionChangeOrder: '',
      // 取消确认时存储原口令占位符
      unConfirmVersionChangeOrder: '',
      // 设置口令表单
      setPasswordDialog: false,
      setPasswordForm: {
        sessionVersionId: "",
        versionChangeOrder: "",
        confirmPassword: "",
      },
      setPasswordRules: {
        versionChangeOrder: [
          { required: true, message: "请输入 6 位数字口令", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "口令必须是 6 位数字", trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请再次输入 6 位数字口令", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "口令必须是 6 位数字", trigger: "blur" },
          { validator: (rule, value, callback) => {
              if (value !== this.setPasswordForm.versionChangeOrder) {
                callback(new Error('两次输入的口令不一致'));
              } else {
                callback();
              }
            }, trigger: "blur" }
        ],
      },
      // 录入口令表单
      inputPasswordDialog: false,
      inputPasswordForm: {
        sessionVersionId: "",
        versionChangeOrder: "",
      },
      inputPasswordRules: {
        versionChangeOrder: [
          { required: true, message: "请输入 6 位数字口令", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "口令必须是 6 位数字", trigger: "blur" }
        ],
      },
      unConfirmDialog: false,
      unConfirmForm: {
        sessionVersionId: "",
        versionChangeOrder: "",
      },
      unConfirmRules: {
        versionChangeOrder: [
          { required: true, message: "请输入 6 位数字口令", trigger: "blur" },
          { pattern: /^\d{6}$/, message: "口令必须是 6 位数字", trigger: "blur" }
        ],
      },
      downloadDialog: false,
      downloadForm: {
        sessionVersionId: "",
      },
      downloadLogList: [],
    };
  },
  watch: {
    "requestForm.planId": "planIdChange",
  },
  methods: {
    async initData() {
      const { data: planList } = await getPlanListApi();
      this.selectList[0].data = planList;
      
      const planId = this.$route.query.planId;
      if (planId) {
        this.requestForm.planId = planId;
        await this.getSectionList();
        await this.search();
      } else if (planList && planList.length > 0) {
        this.requestForm.planId = planList[0].id;
        await this.getSectionList();
        await this.search();
      }
    },

    async getSectionList() {
      if (!this.requestForm.planId) return;
      const { data: secionList } = await getSessionListApi({planId: this.requestForm.planId});
      this.selectList[1].data = [{name:"全部", id: ""}, ...secionList];
      this.requestForm.sessionId = "";
    },

    async planIdChange() {
      await this.getSectionList();
      await this.search();
    },

    async search() {
      let param = {...this.requestForm};
      let res = await getConfirmListApi(param);
      if (res.code) {
        this.tableData = res.data;
      }
    },

    showConfirmDialog(row) {
      // 判断是否需要设置口令还是录入口令
      this.currentVersionChangeOrder = row.versionChangeOrder || '';
      if (!row.versionChangeOrder) {
        // 情况一：versionChangeOrder 为空，需要设置口令
        this.setPasswordForm.sessionVersionId = row.id;
        this.setPasswordForm.versionChangeOrder = "";
        this.setPasswordForm.confirmPassword = "";
        this.setPasswordDialog = true;
      } else {
        // 情况二：versionChangeOrder 不为空，需要录入口令
        this.inputPasswordForm.sessionVersionId = row.id;
        this.inputPasswordForm.versionChangeOrder = "";
        this.inputPasswordDialog = true;
      }
    },

    // 处理设置口令提交
    async handleSetPassword() {
      this.$refs["setPasswordForm"].validate(async (valid) => {
        if (valid) {
          const { code } = await confirmSessionVersionApi({
            sessionVersionId: this.setPasswordForm.sessionVersionId,
            versionChangeOrder: this.setPasswordForm.versionChangeOrder,
          });
          if (code === 1) {
            this.$message.success("确认成功！");
            this.setPasswordDialog = false;
            this.search();
          }
        }
      });
    },

    // 处理录入口令提交
    async handleInputPassword() {
      this.$refs["inputPasswordForm"].validate(async (valid) => {
        if (valid) {
          const { code } = await confirmSessionVersionApi({
            sessionVersionId: this.inputPasswordForm.sessionVersionId,
            versionChangeOrder: this.inputPasswordForm.versionChangeOrder,
          });
          if (code === 1) {
            this.$message.success("确认成功！");
            this.inputPasswordDialog = false;
            this.search();
          }
        }
      });
    },

    showUnConfirmDialog(row) {
      this.unConfirmForm.sessionVersionId = row.id;
      this.unConfirmForm.versionChangeOrder = "";
      this.unConfirmVersionChangeOrder = row.versionChangeOrder || '';
      this.unConfirmDialog = true;
    },

    async handleUnConfirm() {
      this.$refs["unConfirmForm"].validate(async (valid) => {
        if (valid) {
          const { code } = await unConfirmSessionVersionApi({
            sessionVersionId: this.unConfirmForm.sessionVersionId,
            versionChangeOrder: this.unConfirmForm.versionChangeOrder,
          });
          if (code === 1) {
            this.$message.success("取消确认成功！");
            this.unConfirmDialog = false;
            this.search();
          }
        }
      });
    },

    async showDownloadDialog(row) {
      this.downloadForm.sessionVersionId = row.id;
      this.downloadLogList = [];
      await this.getDownloadLog();
      this.downloadDialog = true;
    },

    async getDownloadLog() {
      const res = await downloadGetLogListApi({
        sessionVersionId: this.downloadForm.sessionVersionId,
      });
      if (res.code) {
        this.downloadLogList = res.data || [];
      }
    },

    async handleDownload() {
      const res = await downloadSessionVersionApi({
        sessionVersionId: this.downloadForm.sessionVersionId,
      });
      if (res.code) {
        window.location.href = res.data;
        this.$message.success("下载成功！");
        await this.getDownloadLog();
      }
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped lang="less">
.download-info{
    width: 100%;
    height: auto;
    float: left;
}
.download-info-s{
    width: 20%;
    height: 30px;
    float: left;
}
.download-info-v{
    width: 20%;
    height: 30px;
    float: left;
}
.download-info-u{
    width: 59%;
    height: 30px;
    float: left;
}

// 确认弹窗样式
.alert-text {
  margin: 0;
  line-height: 24px;
  font-size: 13px;
  color: #8a6d3b;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
}

/deep/ .el-alert {
  margin-top: 20px;
  background-color: #fffcf0;
  border: 1px solid #ffe58f;

  .el-alert__title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
  }
  .el-alert__icon{
    margin-top: -120px !important;
  }
}

/deep/ .el-form-item {
  margin-bottom: 24px;

  .el-form-item__label {
    width: 70px !important;
    font-weight: 500;
    color: #333;
    float: left !important;
  }

  .el-form-item__content{
    margin-left: 0px !important;
    float: left;
  }

  .el-input__inner {
    height: 36px;
    font-size: 14px;
  }
}

/deep/ .el-button--round {
  padding: 10px 26px;
  font-size: 14px;
}
</style>